import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService, NationalityService } from 'app/services';
import { Salutation, Suffix, CompanyPosition, MerchantServiceTypeEnum } from 'app/models';
import { MartOnboardingComponent } from 'app/components/home/partners/mart-onboarding/mart-onboarding.component';
import { Utils } from 'app/utils';

enum CreatePartnerTab {
    CompanyDetails = 1,
    PersonalDetails = 2,
    Service = 3,
    Proposal = 4
}

@Component({
    selector: 'detail-mart-partner',
    templateUrl: './detail-mart-partner.component.html',
    styleUrls: ['./detail-mart-partner.component.scss',
        '../../../../../../styles/sidebar.scss',
        '../../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class DetailMartPartnerComponent implements OnInit {
    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.detailMerchant();
        }
    }

    public showDetailMartPartnerSideBar: boolean = false;
    @Input()
    set _showDetailMartPartnerSideBar(value: boolean) {
        this.showDetailMartPartnerSideBar = value;
    }

    @Input() public martOnboardingComponent!: MartOnboardingComponent;

    @Output() changedShowDetailMartPartnerSideBarEmit = new EventEmitter<boolean>();
    changedShowDetailMartPartnerSideBar(increased: any) {
        this.changedShowDetailMartPartnerSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService,
        private nationalityService: NationalityService) { }

    public loading: boolean = false;

    public createPartnerTab = CreatePartnerTab;
    public activeCreatePartnerTab: CreatePartnerTab = CreatePartnerTab.CompanyDetails;

    public merchantServiceTypeEnum = MerchantServiceTypeEnum;
    public companyPositions = CompanyPosition.CompanyPositionList;
    public salutations = Salutation.SalutationList;
    public suffixes = Suffix.SuffixList;

    public merchant: any = {};
    public natioanlities: any = {};

    ngOnInit(): void {
        this.getNationalities();
    }

    public getNationalities() {
        this.nationalityService.getIsActiveNationalities(null, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.natioanlities = data.Items;
        });
    }

    public detailMerchant() {
        this.loading = true;

        const dto = { MerchantId: this.merchantId };

        this.merchantService.detailMerchant(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.merchant = data;

            this.merchant.Birthday = Utils.utcToLocalDate(this.merchant.Birthday);
        });
    }

    public nextTab(tab: CreatePartnerTab) {
        this.activeCreatePartnerTab = tab;
    }

    cancel() {
        this.changedShowDetailMartPartnerSideBar(!this.showDetailMartPartnerSideBar);
    }
}
